import { array, DecoderType, object, string } from "decoders";
import { jsendSuccessDecoder } from "Utils/jsend";

const cbTransferInfo = object({
  rnc: string,
  accounts: array(
    object({
      institution: string,
      number: string,
      type: string,
      currency: string,
    })
  ),
});

export const cbTransferInfoResponseDecoder = jsendSuccessDecoder(cbTransferInfo);

export type CbTransferInfoResponse = DecoderType<typeof cbTransferInfoResponseDecoder>;
